import { render, staticRenderFns } from "./Resolutions.vue?vue&type=template&id=771161ed&"
import script from "./Resolutions.vue?vue&type=script&lang=js&"
export * from "./Resolutions.vue?vue&type=script&lang=js&"
import style0 from "./Resolutions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports